// @ts-nocheck
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, EventEmitter, Input, OnDestroy, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationHelper } from '../../../helpers/navigationClass';
import { PopupFeedbackComponent } from './popup-feedback.component';

@Directive({
  selector: '[lbcaPopupFeedback]',
})
export class PopupFeedbackDirective extends NavigationHelper implements OnDestroy {
  private subscription!: Subscription;
  private popupSubscription!: Subscription;

  constructor(private overlay: Overlay, private instancePopup: PopupInterfaceCommunication) {
    super();
    this.subscribeController();
  }

  ngOnDestroy(): void {
    this.instancePopup.close();
    this.subscription.unsubscribe();
    if (this.popupSubscription) this.popupSubscription.unsubscribe();
  }

  public override onWindowChange(): void {
    this.instancePopup.close();
    this.subscription.unsubscribe();
    if (this.popupSubscription) this.popupSubscription.unsubscribe();
  }

  private subscribeController(): void {
    let overlayRef: OverlayRef | any = null;
    this.subscription = this.instancePopup.popupEmitter.subscribe((popup: popupEventInterface) => {
      if (popup.prop === 'popupShow') {
        if (popup.value)
          overlayRef = this.show(PopupFeedbackComponent, overlayRef, this.overlay, popup.template);
        else overlayRef = this.close(overlayRef);
      }
    });
  }

  private createOverlayRef(overlay: Overlay): OverlayRef {
    const positionStrategy = this.overlay.position().global().bottom('0').centerHorizontally();

    let config;

    if (!this.instancePopup.getBackdrop())
      config = new OverlayConfig({
        positionStrategy,
        hasBackdrop: true,
        backdropClass: 'bg-transparent',
      });
    else config = new OverlayConfig({ positionStrategy });

    return overlay.create(config);
  }

  private show(
    component: any,
    overlayRef: OverlayRef,
    overlay: Overlay,
    template: TemplateRef<Object>
  ): OverlayRef {
    if (!overlayRef) overlayRef = this.createOverlayRef(overlay);
    if (overlayRef.hasAttached()) overlayRef.detach();
    if (this.popupSubscription) this.popupSubscription.unsubscribe();

    overlayRef.overlayElement.classList.remove('hidePopUp');

    if (this.instancePopup.getBlur()) document.getElementById('main-scroll')?.classList.add('blur');

    const ref: any = overlayRef.attach(new ComponentPortal(component));
    ref.instance.templateRef = template;

    if (this.instancePopup.getBackdrop())
      this.popupSubscription = overlayRef.backdropClick().subscribe(() => this.close(overlayRef));

    return overlayRef;
  }

  private close(overlayRef: OverlayRef): void {
    if (!overlayRef) return;
    if (this.popupSubscription) this.popupSubscription.unsubscribe();

    overlayRef.overlayElement.classList.add('hidePopUp');

    setTimeout(() => {
      overlayRef.detach();
      overlayRef.overlayElement.classList.remove('hidePopUp');
      return null;
    }, 700);
  }
}

@Directive()
export class PopupInterfaceCommunication {
  public popupEmitter = new EventEmitter();
  private blur: boolean = false;
  private backdrop: boolean = true;
  private automaticClose: number = 0;

  private timeOutAutoClose: any = null;

  @Input()
  set hasBackdropClick(backdrop: boolean) {
    this.backdrop = backdrop;
  }

  @Input()
  set hasBlur(blur: boolean) {
    this.blur = blur;
  }

  @Input()
  set autoclose(miliseconds: number) {
    this.automaticClose = miliseconds;
  }

  public getBackdrop(): boolean {
    return this.backdrop;
  }

  public getBlur(): boolean {
    return this.blur;
  }

  public show(templateRef: TemplateRef<any>) {
    if (this.timeOutAutoClose) clearTimeout(this.timeOutAutoClose);
    this.popupEmitter.emit({
      prop: 'popupShow',
      value: true,
      template: templateRef,
    });
    if (this.automaticClose > 0)
      this.timeOutAutoClose = setTimeout(() => this.close(), this.automaticClose);
  }

  public close() {
    this.popupEmitter.emit({ prop: 'popupShow', value: false });
  }
}

interface popupEventInterface {
  prop: string;
  value: boolean;
  template?: any;
}
